<template>
	<div class="complain-page">
		<Advertise
			style="margin-left: 14px; margin-right: 14px"
			height="100px"
			href="http://www.baidu.com"
			target="_blank"
			:imgSrc="require('@/assets/images/demo-panel.png')"
		/>

		<div class="content">
            <custom-form />
            <!-- <p v-for="item in 50">{{item}}</p> -->
		</div>

		<footer>
			<p>如有任何疑问请联系我们</p>
			<p>
				电话：<a :href="'tel://'+conf.card_phone" style="text-decoration:underline">{{conf.card_phone}}</a> 微信：<a href="javascript:void(0)" style="text-decoration:underline" @click="copy(conf.card_wechat)">{{conf.card_wechat}}</a>
			</p>
		</footer>
	</div>
</template>

<script>
import Advertise from '@/components/Advertise'
import CustomForm from '@/components/CustomForm';

export default {
	name: 'complain',
	data:()=> ({
		conf: {},
	}),
	created() {
		this.getConf()
	},
	metaInfo: {
		title: '在线投诉',
		titleTemplate: null,
	},
	components: {
        Advertise,
        CustomForm
	},
	methods:{
		getConf() {
			this.$ajax.get('/m/system/conf').then(res => {
				this.conf = res;
			})
		},
		copy(text){
			const input = document.createElement('input')
			document.body.appendChild(input)
			input.setAttribute('value', text)
			input.select()
			if (document.execCommand('copy')) {
				document.execCommand('copy')
				this.$toast.text('复制成功');
			}
			document.body.removeChild(input)
		},
	},
}
</script>

<style lang="less" scoped>
.complain-page {
	display: flex;
	flex-direction: column;
	height: 100%;

	.content {
        flex-grow: 1;
        margin: 0 14px;
	}

	footer {
		text-align: center;
		font-size: 12px;
		color: #999999;
		padding: 20px 0;
		a {
			color: #3c43ec;
			text-decoration: underline;
		}
	}
}
</style>
